import idMixin from '@/mixins/aha-id';
import { KeyCodes } from 'bootstrap-vue/src/utils';

export default {
    mixins: [idMixin],
    mounted() {
        this.checkboxId = this.safeId('_AHA_checkbox_');
    },
    render(h) {
        const iconCheck = h(
            'i', {
                class: 'icon-check'
            }
        );

        const check = h(
            'span', {
                class: this.checkClass,
                attrs: this.containerAttributes
            }, [iconCheck]
        );

        const empty = h(
            'div', {
                attrs: {
                    id: this.checkboxId
                }
            }, [this.$slots.default]
        );

        const container = h(
            'div', {
                class: this.containerClasses,
                on: {
                    click: function(evt) {
                        toggleChecked(evt);
                    },
                    keypress: function(evt) {
                        toggleChecked(evt);
                    }
                }
            }, [check, empty]
        );

        const toggleChecked = (evt) => {
            if(evt.type === 'click' || evt.keyCode === KeyCodes.SPACE) {
                evt.preventDefault();
                this.isChecked = !this.isChecked;
            }
        };

        return container;
    },
    data: function() {
        return {
            isChecked: false,
            checkboxId: null
        };
    },
    props: {
        checkClass: {
            type: String
        }
    },
    computed: {
        containerClasses() {
            return [this.isChecked ? 'is-checked' : '', this.class];
        },
        containerAttributes() {
            return {
                'role': 'checkbox',
                'aria-checked': this.isChecked.toString(),
                'tabindex': 0,
                'aria-labelledby': this.checkboxId
            };
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-recipe-checkbox.js